// 日報コメントのエンティティ
export class ReportComments {
  // 日報コメントID DB型(*autokey)
  public report_comment_id?: number;
  // 授業ID DB型(*autokeyFk)
  public class_id?: number;
  // ユーザーID DB型(*fk)
  public user_id?: string;
  // 登録日時 DB型(DATETIME)
  public init_dt?: Date;
  // 最終修正日時 DB型(DATETIME)
  public last_edit_dt?: Date;
  // 非表示 DB型(*flg)
  public hidden?: boolean;
  // コメント DB型(MEDIUMTEXT)
  public comment?: string;
  static fromDB(record: { [column: string]: any; [column: number]: any }): ReportComments {
    const entity = new ReportComments();
    entity.report_comment_id = record['report_comment_id'];
    entity.class_id = record['class_id'];
    entity.user_id = record['user_id'];
    entity.init_dt = record['init_dt'];
    entity.last_edit_dt = record['last_edit_dt'];
    entity.hidden = record['hidden'];
    entity.comment = record['comment'];
    return entity;
  }
  static getTypeFitEntity(value: any): ReportComments {
    const entity = new ReportComments();
    entity.report_comment_id = value.report_comment_id;
    entity.class_id = value.class_id;
    entity.user_id = value.user_id;
    entity.init_dt = value.init_dt;
    entity.last_edit_dt = value.last_edit_dt;
    entity.hidden = value.hidden;
    entity.comment = value.comment;
    return entity;
  }
}
